<ncp-table #ePrescriptions [(options)]="options"></ncp-table>

@if (previewIsActive()) {
  <div #documentPreview class="row mt-3">
    <div class="col-md-12 text-end mb-2">
      <button
        class="btn btn-danger"
        type="button"
        (click)="closePreview()"
      >
        {{ translations.close_preview }}
      </button>
    </div>

    @if (previewType() === 'application/pdf') {
      <div class="col-md-12">
        <embed
          [src]="previewUrl()"
          type="application/pdf"
          width="100%"
          height="1050px"
        />
      </div>
    }

    @if (previewType() === 'text/html') {
      <div class="col-md-12">
        <iframe
          [src]="previewUrl()"
          width="100%"
          height="1050px"
          style="border: var(--border-2) var(--border-solid) var(--border-primary-blue); border-radius: 4px;"
        ></iframe>
      </div>
    }
  </div>
}
